var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadyToShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "182.000000pt",
    height: "186.000000pt",
    viewBox: "0 0 182.000000 186.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,186.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M630 1668 c-151 -88 -349 -205 -440 -258 l-165 -97 0 -374 0 -374 440 -257 c242 -142 442 -258 445 -258 3 0 118 66 255 146 138 80 337 196 442 257 l193 112 0 371 c0 286 -3 374 -12 382 -12 8 -115 69 -698 410 -86 50 -162 93 -170 96 -9 3 -133 -63 -290 -156z m495 -3 c110 -64 293 -171 408 -238 114 -66 207 -124 207 -127 -1 -3 -80 -51 -176 -107 l-175 -103 -415 242 c-228 133 -414 245 -414 248 0 9 345 209 355 206 6 -2 101 -56 210 -121z m-278 -394 c224 -131 408 -242 410 -247 1 -5 -41 -34 -95 -65 -53 -32 -131 -77 -173 -102 l-77 -45 -68 40 c-68 40 -197 115 -554 323 -102 59 -190 113 -197 119 -9 8 30 36 160 113 95 56 175 102 179 102 4 1 190 -106 415 -238z m-355 -254 l397 -232 1 -342 0 -342 -92 54 c-51 30 -238 139 -415 242 l-323 188 0 339 c0 314 1 338 17 332 9 -4 196 -111 415 -239z m1278 -92 l0 -334 -117 -69 c-65 -38 -239 -140 -388 -227 -148 -86 -285 -166 -303 -177 l-32 -20 2 343 3 343 165 98 c91 53 171 97 178 97 9 1 12 -24 12 -94 0 -52 3 -95 7 -95 11 0 98 53 105 64 4 6 8 56 8 111 l1 100 167 97 c92 53 173 97 180 98 9 0 12 -73 12 -335z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadyToShip);
export default __webpack_public_path__ + "static/media/ReadyToShip.4e66f4ed4d3d18181b3d65f01e8d80b4.svg";
export { ForwardRef as ReactComponent };